import { gql } from "apollo-boost";
import { getApiUrl } from "@/helpers/apiUrl";
interface itemType {
	name: string;
	systemCategoryId: number;
	sequence: number;
	type: string;
	text?: string;
	doesNotProcess: boolean;
	requiresLettering: boolean;
	includeWithParentPO: boolean;
	includeSiblingOnPO: boolean;
	allowsNegativePrices: boolean;
	iconVersion?: string | null;
	iconUrl?: string | null;
}
const state = {
	systemCategories: [] as itemType[],
};

const getters = {
	systemCategories: (state: { systemCategories: itemType[] }) => {
		return state.systemCategories;
	},
	requiresLettering: (state: { systemCategories: itemType[] }) => (systemCategoryId: number) => {
		// Defensive check: return false if systemCategories not loaded
		if (!state.systemCategories || !Array.isArray(state.systemCategories)) {
			return false;
		}
		const category = state.systemCategories.find(
			(category: any) => category.systemCategoryId === systemCategoryId
		);
		return category ? category.requiresLettering : false;
	},
	allowsNegativePrices: (state: { systemCategories: itemType[] }) => (systemCategoryId: number) => {
		// Defensive check: return false if systemCategories not loaded
		if (!state.systemCategories || !Array.isArray(state.systemCategories)) {
			return false;
		}
		const category = state.systemCategories.find(
			(category: any) => category.systemCategoryId === systemCategoryId
		);
		return category ? category.allowsNegativePrices : false;
	},
};

const mutations = {
	setsystemCategories: (state: { systemCategories: itemType[] }, payload: itemType[]) => {
		state.systemCategories = payload;
	},
	addCategory: (state: { systemCategories: itemType[] }, payload: itemType) => {
		state.systemCategories.push(payload);
	},
	editCategory: (state: { systemCategories: itemType[] }, payload: itemType) => {
		const itemIndex = state.systemCategories.findIndex(
			(item) => item.systemCategoryId === payload.systemCategoryId
		);
		state.systemCategories[itemIndex] = payload;
	},
};

const actions = {
	async retrievesystemCategories(
		{ commit }: { commit: (type: string, data: itemType) => void },
		VueInstance: any
	) {
		const query = VueInstance.$apolloProvider.clients.defaultClient.query;
		const res = await query({
			query: gql`
				query {
					systemCategories(take: 500, order: { sequence: ASC }) {
						items {
							name
							systemCategoryId
							type
							doesNotProcess
							requiresLettering
							includeWithParentPO
							includeSiblingOnPO
							allowsNegativePrices
							sequence
							iconVersion
						}
					}
				}
			`,
			fetchPolicy: "no-cache",
		})
			.then((response: any) => response)
			.catch((e: any) => {
				console.log(e);
				return e;
			});

		commit(
			"setsystemCategories",
			res.data.systemCategories.items.map((item: itemType) => ({
				...item,
				text: item.name,
				// Versioned so the browser can cache each icon forever; a new upload changes the URL.
				iconUrl: item.iconVersion
					? getApiUrl(`/api/settings/system-categories/${item.systemCategoryId}/icon?v=${item.iconVersion}`)
					: null,
			}))
		);
	},
	addCategory({ commit }: { commit: (a: string, b: itemType) => void }, payload: itemType) {
		commit("addCategory", payload);
	},
	editCategory({ commit }: { commit: (a: string, b: itemType) => void }, payload: itemType) {
		commit("editCategory", payload);
	},
};

export default {
	state,
	mutations,
	actions,
	getters,
};
